module.exports = __webpack_public_path__ + "fonts/NimbusMonoL-Bold.d99ba120.woff2";